/* ============
 * All Price Fields
 * ============
 *
 * All Price Fields from a country.
 */

import Vue from 'vue';
import store from './../../store';
import priceFieldTransformer from './../../transformers/priceField';

const success = ({ data }, resolve) => {
  const fields = priceFieldTransformer.fetchCollection(data.data.filter(c => c.name !== 'Lokalbrygg'));

  store.dispatch('fetchAllPriceFields', fields);
  resolve(fields);
};

const failed = () => {
};

// Display Price Fields related to a country.
export default (selectedOnly = 0) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`price_fields?selected=${selectedOnly}`)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/priceField/all.js